import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthStore } from '@features/auth/auth.store';
import { AppPaths } from '@core/routes/app-paths';
import { hasFleetAndTeamAccess, hasWorkSessionsReviewAccess } from '@core/utils/role.utils';

/**
 * Restricts Fleet and Team routes to contractor_owner, contractor_dispatcher,
 * trucking_owner, trucking_dispatcher only.
 */
export const fleetTeamAccessGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.user();
  const payload = {
    primaryRole: user?.primaryRole,
    roles: user?.roles,
  };
  const hasAccess = hasFleetAndTeamAccess(payload);

  if (hasAccess) {
    return true;
  }

  if (hasWorkSessionsReviewAccess(payload)) {
    return router.createUrlTree([AppPaths.WORK_SESSIONS]);
  }

  return router.createUrlTree([AppPaths.PROFILE]);
};
